const months = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nīsan",
  "Mayıs",
  "Hazīran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
]

function formatdate(date: Date) {
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
}

export default formatdate
